import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { generateImageCaptcha } from "../../../redux/main/action/main";
import { Input, Skeleton } from "antd";
import styles from "../../../styles/Components/auth/captcha/ImageCaptcha.module.css";
import { IoMdRefresh } from "react-icons/io";
import { IoCloseCircle } from "react-icons/io5";
import { TbReload } from "react-icons/tb";

function ImageCaptcha({
  setCaptchaValue,
  captchaValue = "",
  handleEnterKeyDown,
  loading,
}) {
  const {
    imageCaptchaData: captcha,
    imageCaptchaStatus: status,
    imageCaptchaError: error,
  } = useSelector((state) => state?.main);

  const inputRef = useRef();

  const dispatch = useDispatch();

  const isLoading = status === "loading";

  const refreshCaptcha = () => {
    if (isLoading || loading) return;
    if (setCaptchaValue) {
      setCaptchaValue("");
    }
    dispatch(generateImageCaptcha());
  };

  const changeInput = (e) => {
    setCaptchaValue(e.target.value?.trimStart());
  };

  useEffect(() => {
    if (status !== "loading" && status !== "error" && !captcha?.captcha_id) {
      dispatch(generateImageCaptcha());
    }
  }, [dispatch, captcha?.captcha_id, status]);

  useEffect(() => {
    if (inputRef.current && status === "ready") {
      inputRef?.current?.focus();
    }
  }, [inputRef, status]);

  return (
    <div className={styles.container}>
      {isLoading && <Skeleton.Image rootClassName={styles.loader} active />}
      {!isLoading && captcha?.image && (
        <div className={styles.imageContainer}>
          <img src={captcha?.image} alt="captcha" style={{ width: "200px" }} />
          <div className={styles.refreshIcon} onClick={refreshCaptcha}>
            <IoMdRefresh />
          </div>
        </div>
      )}
      {!error && (
        <div className={styles.inputContainer}>
          <Input
            disabled={isLoading || !captcha?.image || loading}
            placeholder="Enter your answer"
            value={captchaValue}
            name="image_captcha_id"
            onChange={changeInput}
            onKeyDown={handleEnterKeyDown}
            ref={inputRef}
          />
          <IoCloseCircle
            className={styles.resetIcon}
            style={{ opacity: `${captchaValue ? 1 : 0.6}` }}
            onClick={() => setCaptchaValue("")}
          />
        </div>
      )}

      {error && (
        <div className={styles.errorBox}>
          <h4>Something went wrong!</h4>
          <TbReload
            size={24}
            onClick={refreshCaptcha}
            style={{ cursor: "pointer" }}
          />
        </div>
      )}
    </div>
  );
}

export default ImageCaptcha;
